
export const GetSelectOptions = () => {
    const result = [
        {
            label: "Choose a number",
            value: "placeholder"
        }
    ];

    for (let i = 0, ilen = 100; i < ilen; i++) {
        result.push({ label: `${i}`, value: i })
    }
    return result;
}

export const Calculate = (num1, num2) => {

    const result = {
        isValid: false,
        errors: [],
        result: null
    }

    num1 = parseInt(`${num1}`);
    num2 = parseInt(`${num2}`);

    if (Validate(num1, num2, result)) {
        return result;
    }

    result.result = num1 + num2;
    result.label = `${num1} + ${num2} = `
    result.isValid = true;
    return result;
}

const Validate = (num1, num2, result) => {

    if (isNaN(num1)) {
        result.errors.push({
            id: "num1",
            message: "Please enter a valid number"
        })
    }
    if (isNaN(num2)) {
        result.errors.push({
            id: "num2",
            message: "Please select a valid number"
        })
    }

    return result.errors.length > 0
}